module.exports = __webpack_public_path__ + "static/media/logo192.c77a9247.png";